var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"app-lookbook g-flex-box g-flex-box-between g-flex-wrap"},_vm._l((_vm.picList),function(item,index){return _c('div',{key:index,staticClass:"image-item"},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(item),expression:"item"}]})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }